import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { DefaultToneRequest } from '../api/defaulttone/defaulttonerequest';
import { DefaultToneResponse, DefaultToneResponseDtoImpl } from '../api/defaulttone/defaulttoneresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class DefaultToneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<DefaultToneRequest, DefaultToneResponse>
{
    execute(request: DefaultToneRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try 
        {
            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
             {
                let response = new DefaultToneResponseDtoImpl(APIFeatures.DEFAULT_TONE, responseMapper.getStatusMsg());

                this.getAPISuccess(response);
            }
        }
        catch (e)
        {
            this.getAPIFailure(new DefaultToneResponseDtoImpl(APIFeatures.DEFAULT_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
       this.getAPIFailure(new DefaultToneResponseDtoImpl(APIFeatures.DEFAULT_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/defaulttoneapiprocessor.tsx